import {remCalc} from '../_utils'
import colors from './colors'

const shadows = {
    borderShadow: `0px 0px ${remCalc(4)} 0px rgba(0, 0, 0, 0.15)`,
    borderShadowBottom: `0px ${remCalc(4)} ${remCalc(4)} 0px rgba(0, 0, 0, 0.15)`,

    // New shadow tokens
    neutral: {
        xs: colors.neutral.alphaDark[100],
        sm: colors.neutral.alphaDark[200],
        md: colors.neutral.alphaDark[300],
        lg: colors.neutral.alphaDark[400],
        xl: colors.neutral.alphaDark[600],
    },

    accent: {
        xs: colors.brand.alpha[100],
        sm: colors.brand.alpha[200],
        md: colors.brand.alpha[300],
        lg: colors.brand.alpha[400],
        xl: colors.brand.alpha[600],
    },

    positive: {
        xs: colors.green.alpha[100],
        sm: colors.green.alpha[200],
        md: colors.green.alpha[300],
        lg: colors.green.alpha[400],
        xl: colors.green.alpha[600],
    },

    negative: {
        xs: colors.red.alpha[100],
        sm: colors.red.alpha[200],
        md: colors.red.alpha[300],
        lg: colors.red.alpha[400],
        xl: colors.red.alpha[600],
    },
}

export default shadows
